<pl-course-content
  *ngIf="viaSurveyToken()"
  [pageType]="PageType.viaSurvey"
  [tokenSurvey]="viaSurveyToken()"
  [customStepTitle]="'via_survey.before_program_step_title' | translate"
/>
